import firebase from 'firebase'
import Vue, { http, Promise } from 'vue'
import VR from 'vue-resource'
import Rpc from './Rpc'

Vue.use(VR)  // bootstrop promist and http in vue which has already imported

export const deviceTypes = ['', 'power', 'matrix', 'mixer', 'splitter', 'mes', 'dio', 'control', 'ir', 'rs232']
// const eagleFb = new Firebase('https://bageleyes.firebaseio.com/')
const config = {
  apiKey: 'AIzaSyDbTF9hx8jFbSuH2AnGVVhvnGc6QoU83eI',
  authDomain: 'bageleyes.firebaseapp.com',
  databaseURL: 'https://bageleyes.firebaseio.com/'
}
const eagleFb = firebase.initializeApp(config).database().ref()
const PENDING = 0
const AUTHED = 1
const NOAUTH = 2
let authState = PENDING
let authData = null
let userDeviceFavorRef = null
let devLogRef = null
const dbUrl =
  window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' || /^192.168\./.test(window.location.hostname)
  ? 'dbapi.intri.cloud'
  : window.location.hostname.replace(/www/, 'dbapi')

const wsPrxfix = window.location.protocol.replace(/http/, 'ws')
const wsUrl = dbUrl.replace(/dbapi/, wsPrxfix + '//www')
const store = {
  user: null,
  devices: null,   // set initial to null that we can detect it state
  events: []
}

console.log('env', process.env.NODE_ENV)

let app = null
let rpc = {}
if (process.env.NODE_ENV === 'development') {
  rpc = new Rpc('ws://dev.eagleyes.io')
} else {
  rpc = new Rpc(wsUrl)
}

function idMatchsParam (deviceId) {
  return app && app.$route && app.$route.params && app.$route.params.mac === deviceId
}
rpc.subscribe('dsStatusNotifications', ({deviceId, events}) => {
  console.log('got events')
  if (!idMatchsParam(deviceId)) return
  for (let event of events) {
    if (event.event) {
      // to change mapping to all msg
      let temp = Object.keys(event.event)
      if (temp.length !== 1 && event.type === 'mapping') {
        if (temp.length !== 0) {
          if (event.event[temp[0]] === '0') {
            event.msg = 'Set mute to All output'
          } else {
            event.msg = `Input ${event.event[temp[0]]} mapping to All output`
          }
        }
      }
    }
    emit('update', deviceId, event)
  }
})

let getRand = (max, min) => {
  return Math.round(Math.random() * (max - min + 1)) + min
}

rpc.subscribe('dsPowerStatusUpdate', ({deviceId, banks, input}) => {
  if (!idMatchsParam(deviceId)) return
  let inputV = getRand(113.4, 109.2)
  let inputI = getRand(12.4, 15.2)
  let randData = {
    dateTime: Date.now(),
    banks: {
      '1': {current: 0, power: getRand(600, 650)},
      '2': {current: getRand(6.5, 6.4), power: getRand(700, 750)},
      '3': {current: getRand(2.2, 2.4), power: getRand(275, 325)},
      '4': {current: 0, power: getRand(175, 311)},
      '5': {current: 0, power: getRand(175, 311)},
      '6': {current: 0, power: getRand(175, 311)},
      '7': {current: 0, power: getRand(175, 311)},
      '8': {current: 0, power: getRand(175, 311)},
      '9': {current: 0, power: getRand(175, 311)}
    },
    input: {voltage: inputV, current: inputI, power: inputV * inputI}
  }
  if (!deviceId.startsWith('11:22:33:44:55')) { // for real device
    let event = {
      banks: banks,
      input: input
    }
    emit('status', deviceId, event)
  } else { // for virtual device
    console.log('for virtual device')
    emit('status', deviceId, randData)
  }
})

function emit (...arg) {
  if (app == null) throw new Error('app has not been initialed')
  app.$emit(...arg)
  app.$broadcast(...arg)
}

let verifyUnnecessaryTargets = [
  'joe@gmail.com',
  'installer@gmail.com',
  'eagleyestest2017@gmail.com',
  'scptest@gomax-electronics.com.tw'
]

firebase.auth().onAuthStateChanged(async adata => {
  if (adata && !adata.emailVerified && !verifyUnnecessaryTargets.includes(adata.email)) {  // created user, firebase default will be user logged in, but email not verified, so we force logout
    logout()
    authState = NOAUTH
  } else if (adata && adata.emailVerified) {
    authState = AUTHED
  } else if (!adata) {
    authState = NOAUTH
  }

  authData = adata
  console.log('is authed ', authState === AUTHED)

  if (authData && (verifyUnnecessaryTargets.includes(authData.email))) authState = AUTHED

  if (authState === AUTHED) {   // did login
    let { uid } = authData
    http.post('/ajax/access-log', {
      uid,
      isLogin: true
    })
    userDeviceFavorRef = eagleFb.child(`user/${uid}/device_favor`)
    devLogRef = eagleFb.child('devLog')
    userDeviceFavorRef.off('value')
    userDeviceFavorRef.on('value', snap => {
      emit('favoritePort', snap.val())
    })
    let devSnapShot = await eagleFb.child('device').once('value')
    store.devices = devSnapShot.val()
    let userProfileRef = eagleFb.child(`user/${uid}`)
    await userProfileRef.off('value') // must call this, or the on-value dont work after logout
    userProfileRef.on('value', snap => {
      if (snap.val() === null) {  // a new user just signed up ,thus it has no profiles
        let userInfo = {
          name: authData.email.split('@')[0],
          email: authData.email,
          photo_link: authData.photoURL,
          session_time: 0,
          installer: false
        }
        userProfileRef.set(userInfo)
        emit('user', uid, userInfo)
      } else {
        if (!snap.hasChild('session_time')) {
          userProfileRef.update({
            session_time: 0
          })
        }
        store.user = snap.val()
        emit('user', uid, snap.val())
      }
    })
  } else { // when logout
    userDeviceFavorRef = null
    store.user = null
    store.devices = null
  }
})

export function bindVM (vm) {
  app = vm
}

export async function getAuthState () {
  // eslint-disable-next-line
  while (authState === PENDING) {
    await delay(1)
    console.log('wait auth')
  }
  return authState === AUTHED
}

export function getUser () {
  return store.user
}

function delay (sec = 1) {
  if (sec > 10) return console.log('delay cannot bigger than 10s')
  return new Promise(resolve => {
    setTimeout(resolve, sec * 1000)
  })
}

export async function getSpecificDevice (mac) {
  while (!store.devices || !store.devices[mac]) {
    console.log('no auth yet')
    await delay(1)
  }
  return store.devices[mac]
}

export async function getDeviceFavorite (mac) {
  // eslint-disable-next-line
  while (!userDeviceFavorRef) {
    console.log('wait devRef.')
    await delay(1)
  }
  let snap = await userDeviceFavorRef.child(mac).once('value')
  return snap.val()
}

export function changeDeviceNickname (mac, nickname) {
  return eagleFb.child('device').child(mac).update({
    nickname
  })
}

export async function getFirst () {
  // this is called when looking for default devices after entering this system with no configs

  while (!store.devices) {
    console.log('wait devices.')
    await delay(1)
  }

  while (!store.user) {
    console.log('wait user')
    await delay(1)
  }

    // if user has favorite, check ownerId
  if (store.user.installer || store.user.favorite && store.devices[store.user.favorite].ownerId === authData.uid) {
    console.log('got you')
    return {
      mac: store.user.favorite,
      ...store.devices[store.user.favorite]
    }
  } else {
    // if user's favorite not belongs to user anymore
    // list all user devices and return the first
    let userDeviceList = Object.keys(store.devices).filter(mac => {
      return store.devices[mac].ownerId === authData.uid
    }).map(mac => {
      return {
        mac: mac,
        ...store.devices[mac]
      }
    })
    if (userDeviceList.length !== 0) {
      return userDeviceList[0]
    } else {
      return {}
    }
  }
}

export function call (...arg) {
  if (!rpc) throw new Error('rpc has not initialed')
  return rpc.call(...arg)
}

export function login (...arg) {
  return firebase.auth().signInWithEmailAndPassword(...arg)
}

export function logout () {
  store.devices = null
  return firebase.auth().signOut()
}

export function getOnlineDevsRef () {
  return eagleFb.child('devices_online')
}

export function getDeviceRef () {
  // sort the device by online first, firebase default return false then true, so limitToLast return the device from end
  return eagleFb.child('device').orderByChild('online').limitToLast(60)
}

export function getEventLogRef (mac) {
  return devLogRef.child(mac)
}

export function clearEvents (mac) {
  return devLogRef.child(mac).remove()
  // while (store.events.length > 0) {
  //   store.events.pop()
  // }
}
export function changePassword (newPassword) {
  // console.log(eagleFb.auth().currentUser)
  let user = firebase.auth().currentUser
  return user.updatePassword(newPassword)
}
export function changeUserProfile (arg) {
  let { uid } = authData
  return eagleFb.child(`user/${uid}`).update(arg)
}
export function createUser (email, password) {
  return firebase.auth().createUserWithEmailAndPassword(email, password)
}

export function addDevice (params) {
  return http.post('ajax/associate_device', params)
}

export function setUserDeviceFavoritePort (...arg) {
  return userDeviceFavorRef.update(...arg)
}

export function removeFirebaseKey (obj) {
  let nobj = { ...obj }
  delete nobj['.key']
  return nobj
}

export const photos = {
  vga: [
    require('assets/img/input/vga-01.png')
  ],
  outputs: [
    '', // for no imgs
    require('assets/img/test/output1.jpg'),
    require('assets/img/test/output2.jpg'),
    require('assets/img/test/output3.jpg'),
    require('assets/img/test/output4.jpg'),
    require('assets/img/test/output1.jpg'),
    require('assets/img/test/output6.jpg'),
    require('assets/img/test/output7.jpg'),
    require('assets/img/test/output2.jpg')
  ],
  inputs: [
    '', // for no imgs
    require('assets/img/input/01.png'),
    require('assets/img/input/02.png'),
    require('assets/img/input/03.png'),
    require('assets/img/input/04.png'),
    require('assets/img/input/05.png'),
    require('assets/img/input/06.png'),
    require('assets/img/input/07.png'),
    require('assets/img/input/08.png'),
    require('assets/img/input/09.png'),
    require('assets/img/input/10.png'),
    require('assets/img/input/11.png'),
    require('assets/img/input/12.png'),
    require('assets/img/input/13.png'),
    require('assets/img/input/14.png'),
    require('assets/img/input/15.png'),
    require('assets/img/input/16.png'),
    require('assets/img/input/17.png')
  ]
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail)
}

export function hasNewFirmware ({version}) {
  return new Promise((resolve, reject) => {
    let vSp = version.split('.')
    let tail = vSp.pop()
    tail = Number(tail) + 1
    resolve([...vSp, tail].join('.'))
  })
}

export default {
  getAuthState,
  getUser,
  getFirst,
  call,
  login,
  logout,
  getEventLogRef,
  clearEvents,
  createUser,
  changePassword,
  changeUserProfile,
  changeDeviceNickname,
  addDevice,
  setUserDeviceFavoritePort,
  getSpecificDevice,
  photos,
  resetPassword,
  hasNewFirmware
}



// WEBPACK FOOTER //
// ./src/Service.js